<!----
    Author: hjlee
    Description:
        포인트 컨트롤
---->
<template>
  <div class="point-control">
    <input
      :id="'point-calculate-type-amount-' + uid"
      v-model="inputVal.type"
      type="radio"
      :name="'point_calculate_type_' + uid"
      value="absolute"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      @change="onChanged($event)"
    >&nbsp;
    <label :for="'point-calculate-type-amount-' + uid">
      {{ $t('point.text.amount') }}
    </label> &nbsp; &nbsp; &nbsp; &nbsp;
    <input
      :id="'point-calculate-type-rate-' + uid"
      v-model="inputVal.type"
      type="radio"
      :name="'point_calculate_type_' + uid"
      value="rate"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      @change="onChanged($event)"
    >&nbsp;
    <label :for="'point-calculate-type-rate-' + uid">
      {{ $t('point.text.rate') }}
    </label>
    <div class="clear" />
    <currency-input
      v-model="inputVal.value"
      :currency="currency()"
      :decimal-length="2"
      :minimum-fraction-digits="0"
      :class="{'form-control': true}"
      name="earn_point"
      :locale="getCurrencyLocale()"
      :readonly="readonly"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholderText()"
      @change="onChanged($event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Object],
      default: undefined
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      inputVal: {
        type: 'absolute'
      },
      uid: this._uid
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (typeof newVal === 'string') {
          this.inputVal = JSON.parse(newVal)
        } else {
          this.inputVal = newVal
        }
      },
      immediate: true
    }
  },
  methods: {
    currency() {
      const ret = {}
      let symbol
      let position
      if (this.inputVal.type === 'absolute') {
        symbol = this.$t('point.text.unit')
        position = this.$t('point.text.position')
      } else {
        symbol = '%'
        position = 'suffix'
      }
      ret[position] = symbol
      return ret
    },
    getCurrencyLocale() {
      if (this.$i18n && this.$i18n.locale) {
        let locale = this.$i18n.locale.substring(0, 2).toLowerCase()
        locale += '-'
        locale += this.$i18n.locale.substring(3, 5).toLowerCase()
        return locale
      }
      return 'ko-KR'
    },
    onChanged(e) {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
      this.$forceUpdate()
    },
    placeholderText() {
      if (this.value.type === 'absolute') {
        return this.$t('point.text.amount')
      }
      return this.$t('point.text.rate')
    }
  }
}
</script>

<style scoped>
.point-control {
  height: auto;
}
</style>
